// extracted by mini-css-extract-plugin
export default {"halfSection":"responsiveStyles_halfSection__aE+Zi","flipContent":"responsiveStyles_flipContent__XUEOt","content":"responsiveStyles_content__DkAQa"};